import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { openBooking } from "@/lib/api";
import AntMark from "@/components/AntMark";

const SAND =
  "https://images.pexels.com/photos/952670/pexels-photo-952670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Footer() {
  return (
    <footer
      className="relative bg-ink text-white border-t-2 border-black"
      style={{
        backgroundImage: `linear-gradient(rgba(10,10,10,0.93), rgba(10,10,10,0.97)), url(${SAND})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="site-footer"
    >
      <div className="px-5 md:px-10 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-xl">
            <AntMark size={84} dark testId="footer-ant-mark" className="mb-6" />
            <p className="kicker text-lime mb-4">Full-service marketing — Fort Pierce, FL</p>
            <p className="font-display text-5xl md:text-7xl uppercase leading-[0.9]">
              March with<br />the <span className="text-lime">colony.</span>
            </p>
            <button onClick={openBooking} data-testid="footer-book-button" className="btn-brutal-lime mt-8">
              Book a Consultation <ArrowUpRight size={16} />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-10 md:gap-20">
            <div>
              <p className="kicker text-lime mb-4">Sitemap</p>
              <ul className="space-y-3 font-mono text-sm uppercase tracking-widest">
                <li><Link to="/" data-testid="footer-link-home" className="hover:text-lime transition-colors duration-200">Home</Link></li>
                <li><Link to="/services" data-testid="footer-link-services" className="hover:text-lime transition-colors duration-200">Services</Link></li>
                <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-lime transition-colors duration-200">Contact</Link></li>
              </ul>
            </div>
            <div>
              <p className="kicker text-lime mb-4">Contact</p>
              <ul className="space-y-3 font-mono text-sm">
                <li>
                  <a href="tel:+17723324038" data-testid="footer-phone-link" className="inline-flex items-center gap-2 hover:text-lime transition-colors duration-200">
                    <Phone size={14} /> 772-332-4038
                  </a>
                </li>
                <li>
                  <a href="mailto:ants@antcrawler.com" data-testid="footer-email-link" className="inline-flex items-center gap-2 hover:text-lime transition-colors duration-200">
                    <Mail size={14} /> ants@antcrawler.com
                  </a>
                </li>
                <li className="inline-flex items-center gap-2 text-neutral-400">
                  <MapPin size={14} /> Fort Pierce, Florida
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-neutral-800 flex flex-col md:flex-row justify-between gap-4 font-mono text-xs uppercase tracking-widest text-neutral-500">
          <span>© 2026 AntCrawler Marketing LLC</span>
          <span data-testid="footer-not-pest-control">Marketing, not pest control. Wrong colony if you have bugs.</span>
          <Link to="/admin" data-testid="footer-link-admin" className="hover:text-lime transition-colors duration-200">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
